export const newPageNotificationModal = {
	title: "Everything in one place!",
	content:
		"We redesigned this screen so you can create and manage your products with more ease and organization. Explore the new flow at your own pace.",
	primaryActionLabel: "See what's new",
};
